import { fNumber } from '../../../../utils/helpers';
import {
  general,
  includedBusinessLeasing,
} from '../../../pages/fleet-calculator/copy';
import PrimaryButton from '../../ui/PrimaryButton';
import { useCarStoreContext } from '../store/car-store-provider';
import useSettingsStore from '../store/settings-store';
import { CarWithCalculation, TypeOfLeasing } from '../types';

export default function FleetCard({
  car,
  index,
}: {
  car?: CarWithCalculation;
  index: number;
}) {
  const { typeOfLeasing } = useSettingsStore();

  const openCarDetailsModal = useCarStoreContext(
    (state) => state.openCarDetailsModal,
  );
  const openSwitchCarModal = useCarStoreContext(
    (state) => state.openSwitchCarModal,
  );
  const selectableTrimCodes = useCarStoreContext(
    (state) => state.selectableTrimCodes,
  );

  if (!car || !car.car) {
    return (
      <article className="flex flex-col justify-between gap-4 p-4 border rounded-md min-h-[400px] animate-pulse bg-gray-200"></article>
    );
  }

  return (
    <article className="flex flex-col justify-between gap-4">
      <img src={car.car.image} alt={car.car.name} className="w-full h-auto" />
      <div className="flex flex-col md:flex-row justify-between gap-1">
        <div className="min-h-14 grow">
          <h3>{car.car.name}</h3>
          <p>{car.car.type.name}</p>
        </div>
        {selectableTrimCodes.length > 2 ? (
          <div className="">
            <button
              type="button"
              className="bg-black w-full whitespace-nowrap rounded-3xl text-white px-4 py-1"
              onClick={() => openSwitchCarModal(index)}
            >
              Byt modell
            </button>
          </div>
        ) : null}
      </div>
      <ul className="flex flex-col gap-2">
        {typeOfLeasing === TypeOfLeasing.BUSINESS ? (
          <>
            {includedBusinessLeasing.map((item, index) => (
              <li key={index} className="flex justify-between items-center">
                <p>{item.label}</p>
                <p>{item.value}</p>
              </li>
            ))}
          </>
        ) : null}
        <li className="flex justify-between">
          <p>
            {typeOfLeasing === TypeOfLeasing.BUSINESS
              ? 'Business Lease⁵⁾'
              : 'Leasinghyra Finansiell Leasing⁶⁾ (exkl moms)'}
          </p>
          <p>{fNumber(car.calc.monthlyCost)}/mån</p>
        </li>
      </ul>
      <PrimaryButton onClick={() => openCarDetailsModal(car)}>
        {general.showDetails}
      </PrimaryButton>
    </article>
  );
}
